import styled, { css } from 'styled-components';
import { Box } from '@bechtel/gds';

export const BlockHeadingStyled = styled(Box).attrs({
  p: { sm: '500' },
})`
  ${({ theme }) => css`
    background-color: ${theme.colors.grey[200]};
    border-bottom: solid 1px ${theme.colors.grey[300]};
  `}
`;
